import { withStyles } from '@material-ui/core/styles';

/** @deprecated */
export default withStyles;
